import { Button, Dialog, EditIcon, Menu, MoreIcon, Popup, ProviderConsumer, Text, Flex } from '@fluentui/react-northstar';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ArchiveIcon from '../../svg/archive-icon.svg';
import UnArchiveIcon from '../../svg/Un-archive.svg';
import { ARCHIVE_CONFIRMATION_SUBTITLE, ARCHIVE_MODAL_HEADER, TREE_LISTING_CONSTANTS, UNARCHIVE_MODAL_HEADER } from '../shared/utils/constants';
import Style from './UserForm.module.css';
import { ThemeColorScheme } from '../shared/common/TeamsTheme';
import { platformService } from '../shared/services/platform.service';

interface UserListMenuProps {
  id: number;
  isUserLicensed: boolean;
  isArchived: boolean;
  name: string;
  reloadPage: () => void;
}

export const UserListMenu = (props: UserListMenuProps) => {
  
  const platformAPI = new platformService();
  const { t } = useTranslation();
  const history = useHistory();
  const [open, setOpen] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const archiveUser = async (id: number) => {
    setOpenDialog(false);
    try {
      const updatePayload = {
        Id: props.id,
        IsArchived: !props.isArchived
      };
      await platformAPI.patchPlatformUserUser(props.id, updatePayload);
      props.reloadPage();
    } catch (error) {
      toast.error(t('common.something-went-wrong'));
      console.error('Error in archiving/unarchiving user: ', error);
    }
  }

  return (<ProviderConsumer render={globalTheme => (<>
    <Dialog cancelButton={t('common.buttons.cancel')} 
      confirmButton={t(props?.isArchived ? TREE_LISTING_CONSTANTS.unArchive : TREE_LISTING_CONSTANTS.archive)} open={openDialog} onConfirm={() => { setOpenDialog(false); archiveUser(props.id) }} onCancel={() => { setOpenDialog(false); }}
      header={`${props?.isArchived ? UNARCHIVE_MODAL_HEADER : ARCHIVE_MODAL_HEADER} ‘${props?.name}’?`}
      content={`${ARCHIVE_CONFIRMATION_SUBTITLE} ‘${props?.name}’ user.`} style={{ maxWidth: '500px' }} />
    <Popup position='below' className="p-0" open={open}
      onOpenChange={(e, { open }) => { setOpen(open); }}
      trigger={<Button icon={<MoreIcon />} circular text iconOnly title={t('knowledge.knowledge-table.more-options')} />}
      content={<Menu vertical pointing className='p-0' activeIndex={-1}
        items={[
          <span key='edit-icon'>
            <EditIcon disabled={!props.isUserLicensed} outline /> &nbsp;<Text content={t('knowledge.knowledge-table.edit')} disabled={!props.isUserLicensed} />
          </span>,
          <span key='trash-icon'>
            <Flex vAlign='center' gap='gap.smaller' styles={{...ThemeColorScheme(globalTheme.siteVariables)}}>
              {props.isArchived ? <UnArchiveIcon className={`${Style.svgIcon}`} /> : <ArchiveIcon className={`${Style.svgIcon}`} />}
              <Text content={props.isArchived ? TREE_LISTING_CONSTANTS.unArchive : TREE_LISTING_CONSTANTS.archive} />
            </Flex>
          </span>]}
        onItemClick={(e, p) => {
          setOpen(false);
          if (p.index === 0 && props.isUserLicensed)
            history.push(`/users/${props.id}`);
          else if (props.isUserLicensed)
            setOpenDialog(true);
        }} />} />
  </>)} />);
}